/*jshint esversion: 6 */
// Events Components -------------------------------------- *
import '../Views/Feature/Events/Frame/eventListFrame';